import type { SVGProps } from 'react';

/** Figma `fatigue-hoarse.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const FatigueHoarseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame" clipPath="url(#clip0_1320_2636)">
      <path
        id="Vector"
        d="M2 7C4.5 7 4.5 10 7 10C9.5 10 9.5 7 12 7C14.5 7 14.5 10 17 10C19.5 10 19.5 7 22 7M2 13C4.5 13 4.5 15.5 7 15.5C9.5 15.5 9.5 13 12 13C14.5 13 14.5 15.5 17 15.5C19.5 15.5 19.5 13 22 13"
        stroke="#EB8C26"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1320_2636">
        <rect width="22" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
